export default {
  init: {
    minWait: 3000,
  },
  task: {
    waitLast: 1500,
    trottle: 200,
  },
};
